<script>
export default {
  data() {
    return {
      colorTheme: 'system',
      dropdownOpen: false,
    };
  },
  mounted() {
    if (localStorage.getItem('colorTheme')) {
      this.colorTheme = localStorage.getItem('colorTheme');
    }
    document.addEventListener('click', this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  },
  watch: {
    colorTheme(newTheme) {
      if (newTheme === 'system') {
        document.documentElement.removeAttribute('data-color-scheme');
      } else {
        document.documentElement.setAttribute('data-color-scheme', newTheme);
      }
      this.$emit('color-theme-changed', newTheme);
      localStorage.setItem('colorTheme', newTheme);
    },
  },
  computed: {
    mainLabel() {
      if (typeof document !== 'undefined') {
        let lang = document.documentElement.lang;
        if (lang === 'sv') {
          return 'Tema';
        } else {
          return 'Theme';
        }
      }
      return '';
    },
    hiddenLabel() {
      if (typeof document !== 'undefined') {
        let lang = document.documentElement.lang;
        if (lang === 'sv') {
          return 'Nuvarande val: ';
        } else {
          return 'Current choice: ';
        }
      }
      return '';
    },
    lightLabel() {
      if (typeof window !== 'undefined') {
        let lang = document.documentElement.lang;
        if (lang === 'sv') {
          return 'Ljust';
        } else {
          return 'Light';
        }
      }
      return '';
    },
    darkLabel() {
      if (typeof window !== 'undefined') {
        let lang = document.documentElement.lang;
        if (lang === 'sv') {
          return 'Mörkt';
        } else {
          return 'Dark';
        }
      }
      return '';
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    changeColorTheme(theme) {
      this.colorTheme = theme;
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
  },
};
</script>
<template>
  <div class="color-theme-switch">
    <button
      @click="toggleDropdown"
      :aria-expanded="dropdownOpen"
      class="color-theme-switch__button">
      <i
        v-show="colorTheme === 'system'"
        aria-hidden="true"
        class="fas fa-palette"></i>
      <i
        v-show="colorTheme === 'light'"
        aria-hidden="true"
        class="fas fa-sun"></i>
      <i
        v-show="colorTheme === 'dark'"
        aria-hidden="true"
        class="fas fa-moon"></i>
      <span class="main-label">{{ mainLabel }}</span>
    </button>

    <div v-if="dropdownOpen" class="color-theme-switch__dropdown">
      <button @click="changeColorTheme('system')">
        <i aria-hidden="true" class="fas fa-palette"></i>
        <span class="sr-only" v-if="colorTheme === 'system'">{{
          hiddenLabel
        }}</span>
        System
      </button>
      <button @click="changeColorTheme('light')">
        <i aria-hidden="true" class="fas fa-sun"></i>
        <span class="sr-only" v-if="colorTheme === 'light'">{{
          hiddenLabel
        }}</span>
        {{ lightLabel }}
      </button>
      <button @click="changeColorTheme('dark')">
        <i aria-hidden="true" class="fas fa-moon"></i>
        <span class="sr-only" v-if="colorTheme === 'dark'">{{
          hiddenLabel
        }}</span>
        {{ darkLabel }}
      </button>
    </div>
  </div>
</template>
